import type { ArticleCategoryScope } from '@/lib/api/blogApi';

/**
 * Derive le scope de taxonomie a partir du scopePayload deja utilise par les
 * vues scopees ({ clubId } ou { organizationId }).
 *
 * Retourne undefined pour le blog plateforme : le serveur retombe alors sur le
 * referentiel editorial BoulesConnect, comportement historique du SUPER_ADMIN.
 *
 * Ce helper vit dans son propre fichier (et non dans category-manager.tsx) :
 * la regle react-refresh/only-export-components interdit d'exporter autre
 * chose que des composants depuis un fichier qui en exporte un.
 */
export function toCategoryScope(scopePayload?: Record<string, number>): ArticleCategoryScope | undefined {
  if (!scopePayload) return undefined;
  if (scopePayload.clubId) return { clubId: scopePayload.clubId };
  if (scopePayload.organizationId) return { organizationId: scopePayload.organizationId };
  return undefined;
}
